import { ToastService } from "@shared/lib/services";
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";

import { BackednResponse } from "@shared/lib/types";
import { IBucketResponse, IBuckRequest } from "@shared/lib/types/influencer";
import { BUCKET_LIST_QUERY_KEY } from "../constants";
import { BucketService } from "../services/bucket.service";

export function useGetBuckets(params: IBuckRequest) {
  const { data, isLoading, isError, error, refetch } = useQuery<
    BackednResponse<IBucketResponse>
  >({
    queryKey: [...BUCKET_LIST_QUERY_KEY, params],
    queryFn: async () => await BucketService.getBuckets(params),
  });

  const errorMessage = isError && error?.message;

  useEffect(() => {
    if (errorMessage) {
      ToastService.error(errorMessage);
    }
  }, [errorMessage]);
  return {
    buckets: data?.data?.data || [],
    totaldata: data?.data?.pagination.totalCount || 0,
    isError,
    isFetching: isLoading,
    refetch
  };
}
